import { useImpersonator, useUserSession } from '@solinkcorp/authentication';
import React, { useEffect } from 'react';
import { getTrackingSuperProperties } from 'src/core/analytics/common';
import { useEventStandard } from 'utils/EventStandardCache/eventStandardCache';
import AnalyticsLogger from './AnalyticsLogger';

interface AnalyticsLoggerProviderProps {
  children: React.ReactNode;
}

/**
 * Simple component to setup AnalyticsLogger when a user logs in.
 *
 * You need this if you're going to track any events that might create audit events.
 */
const AnalyticsLoggerProvider: React.FC<AnalyticsLoggerProviderProps> = (props) => {
  const eventStandard = useEventStandard();
  const user = useUserSession();
  const impersonator = useImpersonator();

  // Update tracking super-properties and event standard in AnalyticsLogger
  // when they first load and again if they change.  This is a little hacky -
  // it would be better if we had something like a `useAnalyticsLogger()`
  // that returned a configured logger, but that would be a major refactoring job.
  useEffect(() => {
    getTrackingSuperProperties(user, impersonator)
      .then((superProperties) => {
        AnalyticsLogger.setup(eventStandard, superProperties);
      })
      .catch((err) => {
        console.error('Error fetching tracking superProperties:', err);
        AnalyticsLogger.setup(eventStandard, undefined);
      });
  }, [user, impersonator, eventStandard]);

  return <>{props.children}</>;
};

export default React.memo(AnalyticsLoggerProvider);
